module.exports = __webpack_public_path__ + "img/рз_35.10e4cda0.png";